export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-chat-smile-2-line text-xl text-background-50"></i>
                </div>
                <span className="font-heading text-xl text-background-50">
                  51吃瓜网入口
                </span>
              </div>
              <p className="text-sm text-background-300 leading-relaxed">
                51吃瓜网入口为您提供51吃瓜网站入口、51吃瓜网址最新地址与官方入口，51吃瓜网在线快速访问。汇聚全网热门吃瓜内容，解决51吃瓜网怎么进，安全稳定一站式吃瓜入口，让您随时随地掌握最新娱乐热点与话题动态。
              </p>
            </div>

            <div>
              <h3 className="font-heading text-base text-background-50 mb-4">快速导航</h3>
              <ul className="space-y-2.5">
                {[
                  { label: '热门吃瓜', href: '#cards' },
                  { label: '吃瓜热度榜', href: '#ranking' },
                  { label: '焦点专题', href: '#carousel' },
                  { label: '平台特色', href: '#features' },
                  { label: '用户评价', href: '#comments' },
                  { label: '常见问题', href: '#faq' },
                ].map((item) => (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      onClick={(e) => handleNavClick(e, item.href)}
                      className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="font-heading text-base text-background-50 mb-4">热门话题</h3>
              <ul className="space-y-2.5">
                {[
                  { label: '最新娱乐八卦', href: '#topics' },
                  { label: '明星动态追踪', href: '#topics' },
                  { label: '综艺节目热议', href: '#topics' },
                  { label: '网红热点事件', href: '#topics' },
                  { label: '影视剧透讨论', href: '#topics' },
                  { label: '社交平台热帖', href: '#topics' },
                ].map((item) => (
                  <li key={item.label}>
                    <a
                      href={item.href}
                      onClick={(e) => handleNavClick(e, item.href)}
                      className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="font-heading text-base text-background-50 mb-4">合作伙伴</h3>
              <div className="space-y-2.5">
                <p className="text-sm text-background-400">优质合作伙伴持续入驻中</p>
                <div className="flex flex-wrap gap-2 mt-3">
                  <span className="px-3 py-1.5 rounded-md bg-background-800 text-xs text-background-300">媒体平台</span>
                  <span className="px-3 py-1.5 rounded-md bg-background-800 text-xs text-background-300">内容社区</span>
                  <span className="px-3 py-1.5 rounded-md bg-background-800 text-xs text-background-300">资讯站点</span>
                  <span className="px-3 py-1.5 rounded-md bg-background-800 text-xs text-background-300">社交平台</span>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-background-700 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; {new Date().getFullYear()} 51吃瓜网入口. 本站为吃瓜内容聚合导航平台，仅供信息参考。
            </p>
            <div className="flex items-center gap-5">
              <a href="#about" onClick={(e) => handleNavClick(e, '#about')} className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">关于我们</a>
              <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">联系我们</a>
              <a href="#faq" onClick={(e) => handleNavClick(e, '#faq')} className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer">常见问题</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}